/* eslint-disable no-console */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, {useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {matchPath, Link, useNavigate, useLocation} from 'react-router-dom'
import {BsGrid3X3Gap} from 'react-icons/bs'
import {FiBell, FiPlus, FiRss} from 'react-icons/fi'
import {
  VmoBreadcrumb,
  VmoBreadcrumbDivider,
  VmoBreadcrumbSection,
  VmoCard,
  VmoCardContent,
  VmoCardDescription,
  VmoCardMeta,
  VmoDivider,
  VmoDropdown,
  VmoDropdownDivider,
  VmoDropdownHeader,
  VmoDropdownItem,
  VmoDropdownMenu,
  VmoIcon,
  VmoLabel,
  VmoLogoutModal,
  VmoMenu,
  VmoMenuItem,
  VmoMenuMenu,
  VmoModal,
  VmoModalContent,
  VmoModalHeader,
  VmoTooltip,
} from 'vmo-library'

import {logoutCall} from 'actions/index'
import {LOGGED_OUT, LOGOUT} from 'actions/types'
import {getAppToken, getMetadataInfo, getRouteState, setRouteState} from 'utils/local-storage'
import io from 'socket'
import moment from 'moment'
import hourglass from 'assets/hourglass.png'
import {get, getPathWithPrefix, getPermissionTooltipContent, startCase} from 'utils/helper'
import CreateContact from 'components/pages/Customers/CreateContact'
import EmailEditorBox from 'components/common/EmailEditorBox'
import ShowProductModal from 'components/pages/ShowProductModal'
import CreateTask from 'components/pages/Task/CreateTask'
import TicketModel from 'components/common/TicketModel'
import UserNotification from 'components/pages/UserNotification'
import AccountUserImage from 'components/common/AccountUserImage'
import LockPermissionTooltip from 'components/common/LockPermissionTooltip'
import GlobalSearch from 'components/pages/GlobalSearch'
import useUserPermissions from 'hooks/pure/useUserPermission'
import {BREAD_CRUMBS} from 'constants/breadcrumbs'
import {getAllMailInbox} from 'actions/inbox'
import {INBOX_TYPES} from 'constants/enums'
import {KNOWLEDGEBASE_PATH, SETTINGS_PATH} from 'constants/path'

const NavBar = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const [announcementModal, setAnnouncementModal] = useState(false)
  const [productModal, setShowProductModal] = useState(false)
  const [isEmailEditorBoxOpen, setIsEmailEditorboxOpen] = useState(false)
  const [isCreateContactOpen, setIsCreateContactOpen] = useState(false)
  const [isCreateTaskOpen, setIsCreateTaskOpen] = useState(false)

  const [routeNameDynamic, setRouteNameDynamic] = useState(null)
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false)

  const {successLabels = [], type = []} = useSelector(state => state.apiReducer)
  const {inbox: mailboxes = []} = useSelector(state => state.mailInbox)

  const {conversationsPermissions, tasksPermissions, contactsPermissions} = useUserPermissions()
  const allowManageConversationRole = conversationsPermissions?.manage_conversation
  const allowCreateTicketRole = conversationsPermissions?.create_ticket
  const allowManageContactsRole = contactsPermissions?.manage_contacts
  const allowManageTasksRole = tasksPermissions?.manage_tasks

  const dispatch = useDispatch()

  const accountMetaData = getMetadataInfo()

  const [ticketModal, setTicketModal] = useState(false)

  const logout = async () => {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations()
      for (const registration of registrations) {
        if (registration.scope.includes('/support')) {
          await registration.unregister()
        }
      }
    } catch (error) {
      console.error(error)
    } finally {
      dispatch(logoutCall())
    }
  }

  useEffect(() => {
    dispatch(getAllMailInbox())
  }, [dispatch])

  useEffect(() => {
    if (successLabels.includes(LOGOUT)) {
      navigate('/')
      dispatch({
        type: LOGGED_OUT,
      })
    }
  }, [successLabels, dispatch, navigate])

  useEffect(() => {
    let routeState

    if (location.state) {
      setRouteState(location.state)
      routeState = location.state
    } else {
      routeState = getRouteState()
    }
    if (routeState) {
      // use routeState ahead
      setRouteNameDynamic(routeState)
    } else {
      setRouteNameDynamic(null)
      // Prompt no data.
    }
  }, [location.state])

  const isVerifiedInboxAvailable = useMemo(
    () => mailboxes.filter(mail => mail.type === INBOX_TYPES.EMAIL && mail.emailVerified)?.length > 0,
    [mailboxes]
  )

  const crumbs = BREAD_CRUMBS
    // Get all routes that contain the current one.
    .filter(({path}) => {
      const matchUrl = matchPath(path, location.pathname)
      return Boolean(matchUrl)
    })
    // Swap out any dynamic routes with their param values.
    .map(({path, name, isDynamic, key, ...rest}) => {
      const matchUrl = matchPath(path, location.pathname)
      if (!matchUrl) return null

      const {params} = matchUrl

      const rawPath = path.replace('/*', '') // Clean up wildcard

      const resolvedPath = Object.keys(params).length
        ? Object.keys(params).reduce((resolved, param) => resolved.replace(`:${param}`, params[param]), rawPath)
        : rawPath

      const resolvedName = Object.keys(params).length ? (isDynamic ? get([key], routeNameDynamic, name) : name) : name

      return {
        path: resolvedPath, // Use cleaned path for navigation
        name: resolvedName,
        ...rest,
      }
    })
    .filter(Boolean)

  const renderCreateContactModal = () => {
    if (isCreateContactOpen) {
      return <CreateContact setIsCreateContactOpen={setIsCreateContactOpen} isCreateContactOpen={isCreateContactOpen} />
    }
  }

  const renderCreateTaskModal = () => {
    if (isCreateTaskOpen) {
      return <CreateTask setIsCreateTaskOpen={setIsCreateTaskOpen} isCreateTaskOpen={isCreateTaskOpen} />
    }
  }

  const {currentSubscriptionData = {}} = useSelector(state => state.billing)

  const leftDays = () => {
    const days = moment(currentSubscriptionData?.subscription?.endAt).diff(moment(), 'days')
    if (days >= 1) {
      return days
    }
    return `less than ${days + 1}`
  }

  const renderTrial = () => {
    const time = moment(currentSubscriptionData?.subscription?.endAt).diff(moment(), 'miliseconds')
    if (time < 0) {
      return (
        <div>
          Your trial has expired.{' '}
          <Link to={getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.MY_PLAN)}>Click Here</Link> to explore our
          plans.
        </div>
      )
    }
    return (
      <div className="plan-upgrade">
        <img src={hourglass} alt="hourglass" />
        <div>
          Your <b style={{textDecoration: 'underline'}}>Trial</b> Period will End in <b>{leftDays()} days.</b>{' '}
          <Link to={getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.MY_PLAN)}>Upgrade</Link> your plan
        </div>
      </div>
    )
  }

  const renderLogoutModal = () => {
    return (
      <VmoLogoutModal
        open={isLogoutModalOpen}
        onClose={() => setIsLogoutModalOpen(false)}
        header="Logout From Veemo Support"
        subHeader="Are you sure you want to logout?"
        onLogout={logout}
        isLoading={type.includes(LOGOUT)}
      />
    )
  }

  return (
    <VmoMenu size="small" className="vmo-navBar">
      <VmoBreadcrumb size="tiny">
        {crumbs.map(({name, path}, key) =>
          key + 1 === crumbs.length ? (
            <VmoBreadcrumbSection key={key}>{startCase(name)}</VmoBreadcrumbSection>
          ) : (
            <Link key={key} to={path}>
              <VmoBreadcrumbSection>{startCase(name)}</VmoBreadcrumbSection> <VmoBreadcrumbDivider />
            </Link>
          )
        )}
      </VmoBreadcrumb>

      {currentSubscriptionData?.subscription?.status === 'trialing' && renderTrial()}

      <VmoMenuMenu>
        {/* {Object.keys(accountMetaData || {}).every(k => !accountMetaData[k]) && ( */}
        {get(['productTour'], accountMetaData, true) && (
          <VmoMenuItem
            onClick={() => {
              navigate(`/getting-started`)
            }}
          >
            Getting Started
          </VmoMenuItem>
        )}
        {/* )} */}
        <GlobalSearch />
        <VmoDropdown
          icon={
            <VmoTooltip
              content="Create"
              trigger={
                <span>
                  New
                  <FiPlus />
                </span>
              }
            />
          }
          className="link item icon basic-fill-btn new-drop"
          direction="left"
        >
          <VmoDropdownMenu>
            <VmoTooltip
              content={
                !isVerifiedInboxAvailable
                  ? 'Please verify email inbox first'
                  : allowManageConversationRole
                  ? 'New Conversation'
                  : getPermissionTooltipContent({roleAccess: allowManageConversationRole})
              }
              trigger={
                <VmoDropdownItem
                  onClick={() =>
                    isVerifiedInboxAvailable &&
                    allowManageConversationRole &&
                    setIsEmailEditorboxOpen(isEmailEditorBoxOpen => !isEmailEditorBoxOpen)
                  }
                >
                  <VmoIcon name="envelope" /> Email
                </VmoDropdownItem>
              }
            />
            <VmoTooltip
              content={
                !isVerifiedInboxAvailable
                  ? 'Please verify email inbox first'
                  : allowManageConversationRole
                  ? 'New Ticket'
                  : getPermissionTooltipContent({roleAccess: allowManageConversationRole})
              }
              trigger={
                <VmoDropdownItem
                  onClick={() => isVerifiedInboxAvailable && allowCreateTicketRole && setTicketModal(!ticketModal)}
                >
                  <VmoIcon name="ticket" /> Ticket
                </VmoDropdownItem>
              }
            />
            <LockPermissionTooltip isRoleAccessDenied={!allowManageContactsRole}>
              <VmoDropdownItem onClick={() => allowManageContactsRole && setIsCreateContactOpen(!isCreateContactOpen)}>
                <VmoIcon name="user" /> Customers
              </VmoDropdownItem>
            </LockPermissionTooltip>
            <LockPermissionTooltip isRoleAccessDenied={!allowManageTasksRole}>
              <VmoDropdownItem onClick={() => allowManageTasksRole && setIsCreateTaskOpen(!isCreateTaskOpen)}>
                <VmoIcon name="calendar check" /> Task
              </VmoDropdownItem>
            </LockPermissionTooltip>
          </VmoDropdownMenu>
        </VmoDropdown>

        <VmoTooltip
          content="Notifications"
          trigger={
            <VmoDropdown icon={<FiBell />} className="link item icon">
              <VmoDropdownMenu className="notiDrdwn">
                <VmoDropdownHeader>Notifications</VmoDropdownHeader>
                <VmoDivider className="my-0" />
                <div className="notiBody">
                  <UserNotification />
                </div>
              </VmoDropdownMenu>
            </VmoDropdown>
          }
        />

        <VmoTooltip
          content="News and Updates"
          trigger={
            <VmoMenuItem onClick={() => setAnnouncementModal(!announcementModal)}>
              <FiRss />
            </VmoMenuItem>
          }
        />

        <VmoTooltip
          content="Other Products"
          trigger={
            <VmoMenuItem onClick={() => setShowProductModal(!productModal)}>
              <BsGrid3X3Gap />
            </VmoMenuItem>
          }
        />
        <VmoTooltip
          content="My Profile"
          trigger={
            <VmoDropdown icon={<AccountUserImage />} className="link item">
              <VmoDropdownMenu className="nav-agent-profile dd-icon">
                <VmoDropdownItem
                  onClick={() => navigate(getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.MY_PROFILE))}
                >
                  <VmoIcon name="user" /> My Profile
                </VmoDropdownItem>
                <VmoDropdownItem onClick={() => navigate(`/${KNOWLEDGEBASE_PATH.PREFIX}`)}>
                  <VmoIcon name="book" /> Help Center
                </VmoDropdownItem>
                <VmoDropdownItem onClick={() => navigate(`/getting-started`)}>
                  <VmoIcon name="target" /> Getting Started
                </VmoDropdownItem>

                <VmoDropdownDivider />
                <VmoDropdownItem
                  onClick={() => navigate(getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.MY_PROFILE))}
                >
                  <VmoIcon name="setting" /> Settings
                </VmoDropdownItem>
                <VmoDropdownItem
                  onClick={() => navigate(getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.MY_PLAN))}
                >
                  <VmoIcon name="file" /> My Plan
                </VmoDropdownItem>
                <VmoDropdownDivider />
                <VmoDropdownItem onClick={() => setIsLogoutModalOpen(true)}>
                  <VmoIcon name="sign-out alternate" /> Logout
                </VmoDropdownItem>
              </VmoDropdownMenu>
            </VmoDropdown>
          }
        />
      </VmoMenuMenu>
      {productModal && <ShowProductModal setShowProductModal={setShowProductModal} productModal={productModal} />}
      {announcementModal && (
        <VmoModal
          open={announcementModal}
          onClose={() => setAnnouncementModal(false)}
          className="vmo-modal annoucementModal"
          toggle={() => setAnnouncementModal(!announcementModal)}
          closeIcon
        >
          <VmoModalHeader toggle={() => setAnnouncementModal(!announcementModal)}>
            What's new in Veemo Support
          </VmoModalHeader>
          <VmoModalContent className="vmo-modal-body">
            <div className="date">Jan 01, 2021</div>
            <VmoCard fluid>
              <VmoCardContent className="annoCard">
                <h4>Customer Portal</h4>
                <VmoCardMeta>
                  <VmoLabel className="mr-2" color="green" horizontal>
                    Feature Release
                  </VmoLabel>
                </VmoCardMeta>
                <VmoCardDescription>
                  Let your customers track the progress of their conversations and provide updates by giving them access
                  to a central portal.
                </VmoCardDescription>
              </VmoCardContent>
            </VmoCard>
            <div className="date">Jan 01, 2021</div>
            <VmoCard fluid>
              <VmoCardContent className="annoCard">
                <h4>SMS Channel</h4>
                <VmoCardMeta>
                  <VmoLabel className="mr-2" color="green" horizontal>
                    Feature Release
                  </VmoLabel>
                </VmoCardMeta>
                <VmoCardDescription>
                  You can now support and update your customers through SMS channels with our native integration.
                  Connect your SMS number and manage all conversations in one place
                </VmoCardDescription>
              </VmoCardContent>
            </VmoCard>
          </VmoModalContent>
        </VmoModal>
      )}
      {ticketModal && <TicketModel ticketModal={ticketModal} setTicketModal={setTicketModal} />}

      {isEmailEditorBoxOpen && (
        <EmailEditorBox isOpenMailComposer={isEmailEditorBoxOpen} setIsOpenMailComposer={setIsEmailEditorboxOpen} />
      )}
      {renderCreateContactModal()}
      {renderCreateTaskModal()}
      {isLogoutModalOpen && renderLogoutModal()}
    </VmoMenu>
  )
}
export default NavBar
